<template>
  <!-- The pane's foot (SI-3): the PlayerBar from 700 px, the MiniPlayer
       under it, while something plays and nobody holds the foot (a
       selection bar, phone Discover). Panes teleport their own bar into
       #cl-pane-foot. Publishes --cl-player-h so pages pad their scroll. -->
  <div v-if="!lazy || showPlayer" class="pane-foot" :class="{ 'is-phone': phone }">
    <div id="cl-pane-foot" />
    <template v-if="showPlayer">
      <MiniPlayer v-if="phone" />
      <PlayerBar v-else />
    </template>
  </div>
</template>

<script>
import PlayerBar from "@/components/kit/PlayerBar.vue";
import MiniPlayer from "@/components/kit/MiniPlayer.vue";
import nowPlaying from "@/audio/nowPlaying.js";
// Both engines register with nowPlaying when they load.
import "@/audio/audition.js";
import "@/audio/player.js";
import { shellState } from "./shellState.js";
import { viewport } from "./sizeClass.js";

// The bar (64 + its 1 px rule), or the mini player's card and its gap.
const BAR_H = "65px";
const MINI_H = "100px";

function publish(h) {
  if (typeof document !== "undefined") document.documentElement.style.setProperty("--cl-player-h", h);
}

export default {
  name: "PaneFoot",
  components: { PlayerBar, MiniPlayer },
  props: {
    // The window width under which the MiniPlayer replaces the bar.
    phoneBelow: { type: Number, default: 700 },
    // The guest frame: nothing at all until something plays (no pane bar
    // teleports there), so signed-out pages are as they were.
    lazy: { type: Boolean, default: false },
  },
  computed: {
    phone() {
      return viewport.width < this.phoneBelow;
    },
    showPlayer() {
      return !!nowPlaying.state.item && shellState.footClaims === 0;
    },
    height() {
      if (!this.showPlayer) return "0px";
      return this.phone ? MINI_H : BAR_H;
    },
  },
  watch: {
    height: {
      handler: publish,
      immediate: true,
    },
  },
  beforeUnmount() {
    publish("0px");
  },
};
</script>

<style scoped>
.pane-foot {
  position: sticky;
  bottom: 0;
  z-index: 30;
}
.pane-foot.is-phone {
  position: static;
}
</style>
